export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_36',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_36_usd',
			EUR: 'simple_workbook_bundle_36_eur',
			GBP: 'simple_workbook_bundle_36_gbp',
			AUD: 'simple_workbook_bundle_42_99_aud',
			CAD: 'simple_workbook_bundle_42_99_cad',
			DKK: 'simple_workbook_bundle_299_dkk',
			SEK: 'simple_workbook_bundle_379_sek',
			NOK: 'simple_workbook_bundle_339_nok',
			BRL: 'simple_workbook_bundle_127_brl',
			MXN: 'simple_workbook_bundle_599_mxn',
			TRY: 'simple_workbook_bundle_1199_try',
			ARS: 'simple_workbook_bundle_48000_ars',
			COP: 'simple_workbook_bundle_145000_cop',
			CLP: 'simple_workbook_bundle_35000_clp',
		},
		primer: 'prd_wRgpWQU1tV1Z',
	},
	otp: {
		priceMap: {
			USD: 36,
			EUR: 36,
			GBP: 36,
			AUD: 42.99,
			CAD: 42.99,
			DKK: 299,
			SEK: 379,
			NOK: 339,
			BRL: 127,
			MXN: 599,
			TRY: 1199,
			ARS: 48000,
			COP: 145000,
			CLP: 35000,
		},
	},
}
